import Footer from '../components/Footer';
import Navigation from '../components/Navigation';

const PrivacyPolicyPage = () => {
  return (
    <div className="wp-singular page-template page-template-elementor_header_footer page page-id-3249 wp-custom-logo wp-embed-responsive wp-theme-hello-elementor theme-default elementor-default elementor-template-full-width elementor-kit-3179 elementor-page elementor-page-3249">
      <Navigation />

      <div data-elementor-type="wp-page" data-elementor-id="3249" className="elementor elementor-3249" data-elementor-post-type="page">
        <div className="elementor-element elementor-element-d31b407 e-flex e-con-boxed e-con e-parent" data-id="d31b407" data-element_type="container">
          <div className="e-con-inner">
            
            {/* Seção do Título */}
            <div className="elementor-element elementor-element-baa157e e-con-full e-flex e-con e-child" data-id="baa157e" data-element_type="container" data-settings='{"background_background":"classic"}'>
              <div className="elementor-element elementor-element-1175131 elementor-widget elementor-widget-heading" data-id="1175131" data-element_type="widget" data-widget_type="heading.default">
                <div className="elementor-widget-container">
                  <h1 className="elementor-heading-title elementor-size-default">Politique de Confidentialité</h1>
                </div>
              </div>
            </div>

            {/* Seção do Conteúdo de Texto */}
            <div className="elementor-element elementor-element-6415f72 elementor-widget elementor-widget-text-editor" data-id="6415f72" data-element_type="widget" data-widget_type="text-editor.default">
              <div className="elementor-widget-container">
                <h2>1. Introdução</h2>
                <p>A sua privacidade é importante para nós. No Casinoplusportugal (acessível em Casinoplusportugal.site), comprometemo-nos a proteger os dados pessoais dos nossos utilizadores e a garantir a sua utilização de forma transparente, segura e em conformidade com o Regulamento Geral sobre a Proteção de Dados (RGPD).</p>
                
                <h2>2. Dados que Podemos Recolher</h2>
                <p>O nosso site é de natureza informativa e não exige registo. No entanto, podemos recolher dados automaticamente através de cookies, como:</p>
                <ul>
                  <li>Endereço IP</li>
                  <li>Tipo de navegador</li>
                  <li>Páginas visitadas</li>
                  <li>Tempo de navegação</li>
                </ul>
                
                <p>Se nos contactar através do formulário, podemos recolher:</p>
                <ul>
                  <li>Nome e endereço de e-mail</li>
                  <li>Qualquer informação incluída na sua mensagem</li>
                </ul>

                <h2>3. Finalidade da Recolha de Dados</h2>
                <p>Utilizamos os dados para:</p>
                <ul>
                  <li>Melhorar a experiência de navegação no site</li>
                  <li>Responder a pedidos ou mensagens</li>
                  <li>Analisar estatísticas e desempenho do site</li>
                  <li>Cumprir obrigações legais</li>
                </ul>

                <h2>4. Cookies</h2>
                <p>Este site utiliza cookies para recolher informações anónimas de navegação. Pode aceitar, recusar ou gerir cookies nas definições do seu navegador. Para mais detalhes, consulte a nossa [Política de Cookies].</p>

                <h2>5. Partilha de Dados</h2>
                <p>Não partilhamos, vendemos nem alugamos os seus dados pessoais a terceiros, exceto quando exigido por lei.</p>

                <h2>6. Ligações para Terceiros</h2>
                <p>O nosso site contém ligações para casinos licenciados e outras plataformas externas. Não somos responsáveis pelas políticas de privacidade ou conteúdo desses sites.</p>

                <h2>7. Os Seus Direitos</h2>
                <p>Nos termos do RGPD, tem direito a:</p>
                <ul>
                  <li>Aceder aos seus dados</li>
                  <li>Corrigir ou apagar os seus dados</li>
                  <li>Limitar ou opor-se ao seu tratamento</li>
                  <li>Solicitar a portabilidade dos seus dados</li>
                  <li>Apresentar uma reclamação à CNPD</li>
                </ul>
                <p>Para exercer qualquer destes direitos, contacte-nos através de: contacto@Casinoplusportugal.site</p>

                <h2>8. Alterações a Esta Política</h2>
                <p>Reservamo-nos o direito de atualizar esta Política de Privacidade sempre que necessário. A versão mais recente estará sempre disponível nesta página.</p>
              </div>
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;